export function getSafeReturnPath(locationState) {
  const from = locationState?.from;
  if (!from || typeof from.pathname !== 'string' || !from.pathname.startsWith('/') || from.pathname.startsWith('//')) {
    return null;
  }
  return `${from.pathname}${from.search || ''}${from.hash || ''}`;
}
